module.exports = __webpack_public_path__ + "static/img/疫苗.62d8ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apphome/疫苗.png
// module id = 7Vg3
// module chunks = 1